`
    // https://github.com/hongymagic/jQuery.serializeObject
    //
    // Use internal $.serializeArray to get list of form elements which is
    // consistent with $.serialize
    //
    // From version 2.0.0, $.serializeObject will stop converting [name] values
    // to camelCase format. This is *consistent* with other serialize methods:
    //
    //   - $.serialize
    //   - $.serializeArray
    //
    // If you require camel casing, you can either download version 1.0.4 or map
    // them yourself.
    //

    (function ($) {
        $.fn.serializeObject = function () {
            "use strict";

            var result = {};
            var extend = function (i, element) {
                var node = result[element.name];

                // If node with same name exists already, need to convert it to an array as it
                // is a multi-value field (i.e., checkboxes)

                if ('undefined' !== typeof node && node !== null) {
                    if ($.isArray(node)) {
                        node.push(element.value);
                    } else {
                        result[element.name] = [node, element.value];
                    }
                } else {
                    result[element.name] = element.value;
                }
            };

            $.each(this.serializeArray(), extend);
            return result;
        };
    })(jQuery);
`

$chat_container = null
$form = null
$template = null
makleraccessChatConfig = window.makleraccessChatConfig || {}
last_message = 0;

make_msg = (item) ->
  $msg = jQuery('<li><p>' + item.msg + '</p></li>')
  if item.makler == '1'
    $msg.addClass('makler')
  return $msg

init = () ->
  reload = () ->
    jQuery.get makleraccessChatConfig.ajaxurl + '?action=makleraccess_chat&do=get_messages&since=' + last_message, (data) ->
      if data[0]
        last_message = parseInt(data[0].time)
      jQuery.each data, (key, item) ->
        make_msg(item).appendTo($chat_container)
      $chat_container[0].scrollTop = $chat_container[0].scrollHeight

  interval = setInterval(reload, 10000)

newResponse = (response) ->
  if makleraccessChatConfig.online
    make_msg(response).appendTo($chat_container)
    $chat_container[0].scrollTop = $chat_container[0].scrollHeight
  else
    $form.html('<p class="success">Vielen Dank für Ihre Nachricht. Wir werden uns in kürze bei Ihnen melden.</p>')
    $template.addClass('auto-height')

send = (evt) ->
  evt.preventDefault()
  jQuery.post makleraccessChatConfig.ajaxurl + '?action=makleraccess_chat&do=' + ( if makleraccessChatConfig.online then 'send' else 'mail' ), jQuery(this).serializeObject(), newResponse
  jQuery('input, textarea', this).val('')
  return false

jQuery.get makleraccessChatConfig.ajaxurl + '?action=makleraccess_chat&do=settings', (settings) ->
  if !settings.active
    return;

  makleraccessChatConfig = settings

  $template = jQuery('<div class="ma-chat"></div>')
  jQuery('<div class="ma-chat-head">Was können wir für Sie tun?</div>')
    .prepend(jQuery('<img>').attr('src', makleraccessChatConfig.chat_icon))
    .click(() -> $template.toggleClass('open')).appendTo($template)
  $form = jQuery('<form></form>').submit(send)

  if makleraccessChatConfig.online
    $template.addClass('online')

    if makleraccessChatConfig.img and makleraccessChatConfig.name
      $form.addClass('has-main-contact')
      jQuery('<div class="top"><div class="img"><img src="' + makleraccessChatConfig.img + '" alt="' + makleraccessChatConfig.name + '"></div>' + makleraccessChatConfig.name + '</div>').appendTo($form)

    $chat_container = jQuery('<ul class="ma-chat-container"></ul>');
    if makleraccessChatConfig.messages && makleraccessChatConfig.messages.length > 0
      last_message = parseInt(makleraccessChatConfig.messages[0].time)
      jQuery.each makleraccessChatConfig.messages, (key, item) ->
        make_msg(item).prependTo($chat_container)

      $chat_container.appendTo($form)
      init()
      $template.addClass('open')
    else
      $form.addClass('no-name')
      $form.on 'submit.first', () ->
        jQuery('#ma-chat-name').remove()
        $form.off 'submit.first'
        $form.removeClass('no-name')
        init()

      $chat_container.appendTo($form)
      jQuery('<input type="text" required="required" id="ma-chat-name" name="name" placeholder="Ihr Name">').appendTo($form)

    jQuery('<input required="required" id="ma-chat-msg" name="msg" placeholder="Ihre Nachricht">').appendTo($form)
  else
    if makleraccessChatConfig.allow_beratungstermin and makleraccessChatConfig.allow_offline_message
      $form.html('Zur Zeit sind wir leider nicht online, Sie können jedoch einen Beratungstermin vereinbaren oder uns eine Nachricht hinterlassen.')
    else if makleraccessChatConfig.allow_beratungstermin
      $form.html('Zur Zeit sind wir leider nicht online, Sie können jedoch einen Beratungstermin vereinbaren.')
    else
      $form.html('Zur Zeit sind wir leider nicht online, Sie können uns jedoch auch eine Nachricht hinterlassen.')

    if makleraccessChatConfig.allow_beratungstermin
      $template.addClass('offline--beratungstermin')
      $form.html($form.html() + '<br><a href="' + makleraccessChatConfig.allow_beratungstermin + '" class="btn button">&raquo; Beratungstermin vereinbaren</a>')

    if makleraccessChatConfig.allow_offline_message
      $template.addClass('offline--message')
      $_tmp = jQuery('<p>')
      jQuery('<input type="text" required="required" id="ma-chat-name" name="name" placeholder="Ihr Name">').appendTo($_tmp)
      jQuery('<input type="email" required="required" id="ma-chat-email" name="email" placeholder="Ihre E-Mail-Adresse">').appendTo($_tmp)
      jQuery('<textarea required="required" id="ma-chat-msg" name="msg" placeholder="Ihre Nachricht"></textarea>').appendTo($_tmp)
      $_tmp.appendTo($form)

  if makleraccessChatConfig.online or makleraccessChatConfig.allow_offline_message
    jQuery('<button type="submit">Absenden</button>').appendTo($form)
  jQuery('<div class="ma-chat-content"></div>').append($form).appendTo($template)
  $template.appendTo(jQuery('body').addClass('has-ma-chat'))
  if $chat_container?.length
    $chat_container[0].scrollTop = $chat_container[0].scrollHeight